export default __webpack_public_path__ + "static/media/arrow_right_green.3a41274a.svg";